<template>
    <div class="head_all">
      <div class="head_nei">
        <div class="head_q">
      <div class="head_logo"><img src="../../assets/logo.jpg" alt="" class="logo"></div>

      <div class="head_menu">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" >

              <el-menu-item :index="item.headIndex" v-for="item in menuData">
                <router-link :to="item.headPath">
                  <li>{{item.headText}}</li>
                </router-link></el-menu-item>


    </el-menu>

      </div>
        </div>
      <div class="head_sn">
        <div class="tbp">
          <img src="../../assets/image/ss1.png"  alt="" class="zy" @click="choice()">
        </div>
            <div  class="tbp_1" v-show="showimg" v-for="item in language" @click="checkM(item.path)">{{item.text1}}</div>

      </div>
      </div>
  </div>

</template>
<script>
export default {
  data() {
    return {
      showimg:false,
      language:[
        {
          text1:"中文",
          path:"zh"
        },
        {
          text1:"English",
          path:"en"
        }
      ],

      activeIndex:1,
      menuData:[{
        headIndex: 1,
        headText:"Homepage",
        headPath:"/en",
      },
        {
          headIndex: 2,
          headText:"Product Technology",
          headPath:"/en/product",
        },
        {
          headIndex: 3,
          headText:"Solutions",
          headPath:"/en/companyProfile",
        },
        {
          headIndex: 4,
          headText:"Clinical Applications",
          headPath:"/en/clinical",
        },
        {
          headIndex: 5,
          headText:"About Us",
          headPath:"/en/aboutUs",
        },
        {
          headIndex: 6,
          headText:"News Center",
          headPath:"/en/news2",
        },
        {
          headIndex: 7,
          headText:"Contact Us",
          headPath:"/en/contactUs",
        }
      ]
    }
  },
  name: "hearder",
  created() {
    let that = this;
    let urlData = that.$route.path;
    console.log(urlData);
    for(let item in that.menuData){
      let itemData =  that.menuData[item]
      if(urlData == itemData.headPath){
        that.activeIndex = itemData.headIndex;
      }
    }

  },
  methods:{
    choice(){
      let that = this;
      if(that.showimg){
        that.showimg = false;
      } else {
        that.showimg = true;
      }
    },
    checkM(path){
      let that = this;

      let urlData = that.$route.path;
      let urlAll = window.location.href;
      let param = "";
      if(urlAll.indexOf("?") > 0){
        param = urlAll.substring(urlAll.indexOf("?"));
      }
      console.log(param);

      if('zh' == path){
        console.log("切："+that.$parent.message)
        if(that.$parent.message == 'en') {
          console.log("22"+urlData)
          console.log(urlData.length)
          if (urlData.length >= 3) {
            let toPath = urlData.substring(3);
            if(toPath == ""){
              toPath = "/"
            }
            console.log(toPath)
            this.$router.push(toPath+param);
          } else {
            console.log('/')
            this.$router.push('/');
          }
        }

      } else {
        if(that.$parent.message == 'zh') {
          if (urlData == '/') {
            this.$router.push('/en');
          } else {
            let toPath = '/en' + urlData;
            this.$router.push(toPath+param);
          }
        }
      }
      that.$parent.message = path;
      that.showimg = false;
    }
  }
}
</script>
<style>
.tbp_1{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  height: 35px;
  width: 70px;
  cursor: pointer;
}
.tbp{
  display: flex;
  width: 70px;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.el-menu--horizontal>.el-menu-item.is-active{
  border-bottom: 2px solid #59b200 !important;
}
.logo{
  width: 115px;
  height: 64px;
}
.head_sn{
  display: block;
  align-items: center;
  justify-content: right;
  margin-right: 10px;
  z-index: 100;
}
.zy{
  width: 20px;
  height: 20px;
}
.head_all{
  width: 1920px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
}
.head_q{
  display: flex;
  height: 100%;
}
.head_nei{
  width: 1176px;
  height: 100%;
  display: flex;
  background-color: #FFFFFF;
  justify-content: space-between;
}

</style>



// WEBPACK FOOTER //
// src/components/en/hearder.vue